import Script from 'next/script'
import { useEffect, useState } from 'react'

import { useAds } from '@/components/providers/AdsProvider'
import { AD_GLOBAL_STATUS } from '@/defs/ad'

export const MediavineInitializer = () => {
  const { adsDisabled } = useAds()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  return adsDisabled ? (
    <div
      data-blocklist-adhesion-desktop='1'
      data-blocklist-adhesion-mobile='1'
      data-blocklist-adhesion-tablet='1'
      data-blocklist-auto-insert-sticky='1'
      data-blocklist-chicory='1'
      data-blocklist-content-desktop='1'
      data-blocklist-content-mobile='1'
      data-blocklist-in-image='1'
      data-blocklist-interstitial-desktop='1'
      data-blocklist-interstitial-mobile='1'
      data-blocklist-leaderboard='1'
      data-blocklist-recipe='1'
      data-blocklist-sidebar-atf='1'
      data-blocklist-sidebar-btf='1'
      data-blocklist-universal-player-desktop='1'
      data-blocklist-universal-player-mobile='1'
      data-blocklist-zergnet='1'
      id='mediavine-settings'
    />
  ) : (
    <>
      <Script
        async
        data-cfasync='false'
        data-noptimize='1'
        src='//scripts.mediavine.com/tags/edhrec.js'
        strategy='lazyOnload'
        type='text/javascript'
      />
      <div
        data-blocklist-adhesion-desktop={AD_GLOBAL_STATUS.ADHESION_DESKTOP ? undefined : '1'}
        data-blocklist-adhesion-mobile={AD_GLOBAL_STATUS.ADHESION_MOBILE ? undefined : '1'}
        data-blocklist-adhesion-tablet={AD_GLOBAL_STATUS.ADHESION_TABLET ? undefined : '1'}
        id='mediavine-settings'
      />
      <Script async src='https://tags.spacecowmediaads.com/edhrec.js' />
    </>
  )
}
